import { Route } from "react-router-dom";
import DashboardTemplate from "../../Template/DashboardTemplate";
import AddAsset from "../../Pages/Assets/AddAssetsVoucher/AddAsset";
import ResourceNotFound from "../ResourceNotFound";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import AssetsNestedRoute from "../../Pages/Assets/AssetsNestedRoute";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import { ISilderName, ItemRoutesProps } from "./PageRoute";
import AddDisposeAsset from "../../Pages/Assets/Dispose/AddDisposeAsset";

const AssetsRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/* ----------- Assets Route ----------- */}
      <Route
        path={`/${currentClient?.id}/asset/*`}
        element={
          findUserPremission(
            [
              "Voucher.Asset.11.View",
              "Voucher.Asset.DisposedAsset.View",
              "Master.AssestsLocation.View",
            ],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesInvoiceTemplate
              element={<AssetsNestedRoute />}
              silderName={ISilderName.FixedAsset}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
              ]}
              menuprops={[
                {
                  showData: "Asset Purchase",
                  addButton: "assetPurchase",
                },
                {
                  showData: "Depreciations",
                  addButton: "depreciations",
                },
                {
                  showData: "Disposed",
                  addButton: "disposed",
                },
                {
                  showData: "Assets Items",
                  addButton: "assetsitems",
                },
                {
                  showData: "Location",
                  addButton: "location",
                },
                {
                  showData: "Categories",
                  addButton: "categories",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/asset/addFixedAsset`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Asset Purchase",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/asset/addDisposed`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddDisposeAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Disposed",
                  path: `/books/clients/${currentClient?.id}/asset/disposed`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/asset/editFixedAsset/:updateId`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Asset Purchase",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/asset/editDisposed/:updateId`}
        element={
          <DashboardTemplate
            element={<AddDisposeAsset />}
            breadcrumprops={[
              {
                item: "Assets",
                path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
              },
              {
                item: "Disposed",
                path: `/books/clients/${currentClient?.id}/asset/disposed`,
              },
              {
                item: "Edit",
              },
            ]}
          />
        }
      />
      <Route
        path={`${currentClient?.id}/asset/cloneFixedAsset/:cloneId`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Asset Purchase",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Clone",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/asset/editFixedAssetDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Asset Purchase",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Disposed  */}
      <Route
        path={`${currentClient?.id}/asset/cloneDisposed/:cloneId`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddDisposeAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Disposed Asset",
                  path: `/books/clients/${currentClient?.id}/asset/disposed`,
                },
                {
                  item: "Clone",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/asset/editDisposedDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Asset.11.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddDisposeAsset />}
              breadcrumprops={[
                {
                  item: "Assets",
                  path: `/books/clients/${currentClient?.id}/asset/assetPurchase`,
                },
                {
                  item: "Disposed Asset",
                  path: `/books/clients/${currentClient?.id}/asset/disposed`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
    </>
  );
};

export default AssetsRoute;
